export default function DieuKhoan() {
  return (
    <div className="w-full mt-24 md:mt-36 container mx-auto px-4 pb-20 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-8 text-blue-600 text-center uppercase">
        ĐIỀU KHOẢN SỬ DỤNG
      </h1>

      <p className="mb-6 italic text-gray-600">
        Cảm ơn bạn đã truy cập website{" "}
        <span className="font-semibold text-blue-500">BlueSkyIT.vn</span>. Khi
        sử dụng trang web này, bạn đồng ý tuân thủ các điều khoản sử dụng sau
        đây. Vui lòng đọc kỹ trước khi tiếp tục truy cập.
      </p>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          1. Phạm vi điều khoản
        </h2>
        <p>
          Những điều khoản này áp dụng cho tất cả người truy cập và sử dụng
          trang web BlueSkyIT. Bạn cam kết rằng mình đã đủ 18 tuổi hoặc được
          phép theo quy định pháp luật để sử dụng trang web này.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          2. Quyền sở hữu trí tuệ
        </h2>
        <p>
          Toàn bộ nội dung, hình ảnh, video, logo, và tên thương hiệu hiển thị
          trên website BlueSkyIT đều thuộc sở hữu của BlueSkyIT hoặc các đối tác
          có liên quan. Nghiêm cấm sao chép, sử dụng hoặc phân phối nội dung khi
          chưa có sự đồng ý bằng văn bản.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          3. Sử dụng website
        </h2>
        <p>
          Bạn chỉ được phép sử dụng website vào mục đích hợp pháp. Nghiêm cấm sử
          dụng website cho các hoạt động bất hợp pháp, bao gồm nhưng không giới
          hạn, việc truyền tải nội dung có hại, gian lận, hay vi phạm quyền của
          bên thứ ba.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          4. Tài khoản người dùng
        </h2>
        <p>
          Khi tạo tài khoản trên BlueSkyIT, bạn có trách nhiệm bảo mật thông tin
          đăng nhập và các hoạt động liên quan đến tài khoản của bạn. BlueSkyIT
          không chịu trách nhiệm cho bất kỳ tác hại nào phát sinh từ việc sử
          dụng tài khoản không đúng cách.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          5. Chính sách bảo mật
        </h2>
        <p>
          BlueSkyIT cam kết bảo vệ thông tin cá nhân của người dùng theo quy
          định của pháp luật Việt Nam. Vui lòng tham khảo{" "}
          <a
            href="/chinh-sach-bao-mat"
            className="text-blue-500 hover:underline font-medium"
          >
            Chính sách bảo mật
          </a>{" "}
          để biết thêm chi tiết.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          6. Giới hạn trách nhiệm
        </h2>
        <p>
          BlueSkyIT không chịu trách nhiệm với bất kỳ thiệt hại nào, dù trực
          tiếp hay gián tiếp, phát sinh từ việc sử dụng trang web. BlueSkyIT
          không đảm bảo website không có lỗi hoặc khả năng truy cập liên tục.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          7. Thay đổi điều khoản
        </h2>
        <p>
          BlueSkyIT có quyền thay đổi nội dung điều khoản sử dụng bất kỳ lúc nào
          mà không cần thông báo trước. Bạn có trách nhiệm thường xuyên kiểm tra
          để đảm bảo hiểu rõ và tuân theo điều khoản được đề cập đến trong phần
          này.
        </p>
      </section>
    </div>
  );
}
